(function (app, ng) {
    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider
                .state("Home.Tools.MarketingTrackerNew.DigitalMarketing.ActOn.ActOnCampaignInsights",
                    {
                        url: "/CampaignInsights/{actOnCampaignId}",
                        params: { actOnCampaign: null },
                        component: "actOnCampaignInsights",
                        PageTitle: "Act-On Campaign Insights | Marketing Tracker",
                        resolve: {
                            onBehalfOfUser: ["userApi", "permissionService", function (userApi, permissionService) {
                                var onBehalfOfUserId = permissionService.getOnBehalfOfUserId();
                                if (onBehalfOfUserId)
                                    return userApi.get(onBehalfOfUserId).catch(ng.noop);
                                return null;
                            }]
                        }
                    });
        }
    ]);

    app.component("actOnCampaignInsights",
        {
            templateUrl: "App/Tools/MarketingTrackerNew/DigitalMarketing/ActOn/ActOnCampaignInsights/act-on-campaign-insights-template.html",
            controller: actOnCampaignInsightsController,
            bindings: {
                user: "<",
                onBehalfOfUser: "<"
            }
        });

    actOnCampaignInsightsController.$inject = [
        "figToaster",
        "marketingTrackerActOnApi",
        "$stateParams",
        "$scope"
    ];
    function actOnCampaignInsightsController(
        figToaster,
        marketingTrackerActOnApi,
        $stateParams,
        $scope
    ) {
        var $ctrl = this;
        ng.extend($ctrl,
            {
                ui: {
                    loadingData: false,
                    reloadingData: false,
                    selectedMessage: false,
                    loadingMessage: false,
                    showPercent: true
                },
                getMessageMetrics: getMessageMetrics,
                refreshData: refreshData,
                togglePercent: togglePercent,
                show: {
                    opened: showOpened,
                    notOpened: showNotOpened,
                    bounced: showBounced,
                    clicked: showClicked,
                    optedOut: showOptedOut,
                    spammed: showSpammed
                }
            });

        var messageSentChart = false;
        $scope.$on("chart-create", function (event, instance) {
            if (instance.canvas.id === "messageSentChart") {
                messageSentChart = instance;
                $scope.chart = instance.chart;
            }
        });

        function _getCampaignDetails(campaignId) {
            $ctrl.ui.loadingData = true;
            return marketingTrackerActOnApi.getCampaignAssets(campaignId)
                .then(function (response) {
                    $ctrl.selectedCampaign = response;
                })
                .catch(function (error) {
                    console.log("Error: " + error.data);
                    var message = "There was a problem retrieving your data. Please try again shortly.";
                    var toastClass = "is-error";
                    figToaster.showSimple(message, "top", toastClass);
                })
                .finally(function () {
                    //$ctrl.getMessageMetrics($ctrl.selectedCampaign.assets[0].msgId);
                    $ctrl.ui.loadingData = false;
                });
        }

        function togglePercent() {
            $ctrl.ui.showPercent = !$ctrl.ui.showPercent;
        }

        function getMessageMetrics(messageId) {
            $ctrl.ui.selectedMessage = true;
            $ctrl.ui.loadingMessage = true;
            marketingTrackerActOnApi.getMessageReport(messageId)
                .then(function (response) {

                    var delivered = response.sent - response.bounced;

                    $ctrl.selected = {
                        id: messageId,
                        chart: {
                            data: [
                                response.opened[0],
                                response.notopened,
                                response.bounced
                            ],
                            labels: ["Opened", "Not Opened", "Bounced"],
                            backgroundColors: ["#187EEB", "#616161", "#EF5753"],
                            options: {
                                legend: {
                                    display: true,
                                    position: "left",
                                    //onHover: function(event) {
                                    //    event.target.style.cursor = "pointer";
                                    //},
                                    onClick: function (event, label) {
                                        if (label.text.includes("Bounced")) {
                                            showBounced();
                                        }
                                        else if (label.text.includes("Not Opened")) {
                                            showNotOpened();
                                        }
                                        else if (label.text.includes("Opened")) {
                                            showOpened();
                                        }
                                    },
                                    labels: {
                                        generateLabels: function() {
                                            return [
                                                {
                                                    text: "Opened (" + response.opened[0] + ")",
                                                    fillStyle: "#187EEB",
                                                    hidden: false,
                                                    lineWidth: 0,
                                                    strokeStyle: "#FFFFFF"
                                                },
                                                {
                                                    text: "Not Opened (" + response.notopened + ")",
                                                    fillStyle: "#616161",
                                                    hidden: false,
                                                    lineWidth: 0,
                                                    strokeStyle: "#FFFFFF"
                                                },
                                                {
                                                    text: "Bounced (" + response.bounced + ")",
                                                    fillStyle: "#EF5753",
                                                    hidden: false,
                                                    lineWidth: 0,
                                                    strokeStyle: "#FFFFFF"
                                                }
                                            ];
                                        }
                                    }
                                },
                                cutoutPercentage: 55
                                //,
                                //onHover: function(event) {
                                //    var active = messageSentChart.getElementsAtEvent(event);
                                //    if (active.length) {
                                //        event.target.style.cursor = "pointer";
                                //    } else event.target.style.cursor = "default";
                                //},
                                //onClick: function (event) {
                                //    var active = messageSentChart.getElementsAtEvent(event);
                                //    if (active.length === 1) {
                                //        var element = active[0];
                                //        // indexed in order of provided data
                                //        if (element._index === 0) {
                                //            showOpened();
                                //        }
                                //        else if (element._index === 1) {
                                //            showNotOpened();
                                //        }
                                //        else if (element._index === 2) {
                                //            showBounced();
                                //        }
                                //    }
                                //}
                            }
                        },
                        sent: response.sent,
                        opened: response.opened[0],
                        clicked: response.clicked[0],
                        optedOut: response.optout,
                        spam: response.spam,
                        bounced: response.bounced,
                        openRate: Math.round(response.opened[0] / delivered * 100),
                        clickRate: Math.round(response.clicked[0] / delivered * 100),
                        optOutRate: Math.round(response.optout / delivered * 100),
                        spamRate: Math.round(response.spam / delivered * 100),
                        bounceRate: Math.round(response.bounced / response.sent * 100)
                    };
                })
                .finally(function() {
                    $ctrl.ui.loadingMessage = false;
                });
        }

        $scope.loadDataSet = function (elements, e) {
            var pos = Chart.helpers.getRelativePosition(e, $scope.chart);

            var intersect = elements.find(function (element) {
                return element.inRange(pos.x, pos.y);
            });
            if (intersect) {
                var element = intersect._index;

                if (element === 0) {
                    showOpened();
                }
                else if (element === 1) {
                    showNotOpened();
                }
                else if (element === 2) {
                    showBounced();
                }
            }
        };

        function showOpened() {
            console.log("Display Opened Contacts");
        }

        function showNotOpened() {
            console.log("Display Not Opened Contacts");
        }

        function showBounced() {
            console.log("Display Bounced Contacts");
        }

        function showClicked() {
            console.log("Display Clicked Contacts");
        }

        function showOptedOut() {
            console.log("Display Opted Out Contacts");
        }

        function showSpammed() {
            console.log("Display Spammed Contacts");
        }

        function refreshData() {
            $ctrl.ui.selectedMessage = false;
            $ctrl.ui.reloadingData = true;
            _getCampaignDetails($stateParams.actOnCampaignId)
                .finally(function () {
                    $ctrl.ui.reloadingData = false;
                });
        }

        $ctrl.$onInit = function () {
            $ctrl.actOnCampaignId = $stateParams.actOnCampaignId;
            _getCampaignDetails($stateParams.actOnCampaignId);
        };
    }

})(window.app, window.angular); //jshint ignore:line